export default "bid-price-unit = {$currency}/t\nbid-price-per-km-unit = {$currency}/t/km"